<script setup lang="ts">
import { onMounted, useTemplateRef } from "vue";

import BaseButton from "@/components/ui/BaseButton/BaseButton.vue";
import { useNativeEvents } from "@/composables/useNativeEvents";
import type { Icon } from "@/model/icon";

defineOptions({ inheritAttrs: false });

defineProps<{ value: string; icon?: Icon }>();

const triggerRef = useTemplateRef("trigger");
const buttonRef = useTemplateRef("button");
defineExpose({ focus: () => void buttonRef.value?.focus() });

const { addEventListener } = useNativeEvents();

onMounted(() => {
  addEventListener(document, "keydown", keydown, { capture: true });
});

function keydown(e: KeyboardEvent) {
  if (e.key === "Escape") {
    if (triggerRef.value?.contains(e.target as Node)) {
      e.stopImmediatePropagation();
    }
  }
}
</script>

<template>
  <div ref="trigger">
    <BaseButton
      ref="button"
      variant="outlined"
      color="grey"
      class="dropdown-trigger"
      data-dropdown-trigger
      :icon-before="icon"
      icon-after="arrow/chevron-down"
      v-bind="$attrs"
    >
      <span>{{ value }}</span>
    </BaseButton>
  </div>
</template>

<style lang="scss">
.base-button.dropdown-trigger {
  display: flex;
  justify-content: space-between;
  max-width: 100%;
}
</style>
